import { Box, CircularProgress } from "~/common/mui";

export const LoadingScreen = () => {
  return (
    <Box sx={{ display: "grid", placeItems: "center", minHeight: "300px", height: "100%", width: "100%" }}>
      <CircularProgress size={40} />
    </Box>
  );
};
